"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GA4ItemListType = void 0;
var GA4ItemListType;
(function (GA4ItemListType) {
    GA4ItemListType["ListView"] = "list view";
    GA4ItemListType["TileView"] = "tile view";
    GA4ItemListType["MapView"] = "map view";
    GA4ItemListType["MapViewList"] = "map view product list";
    GA4ItemListType["MapViewOverlay"] = "map view map overlay";
    GA4ItemListType["MapViewFilter"] = "map view set in filter menu";
})(GA4ItemListType || (exports.GA4ItemListType = GA4ItemListType = {}));
//# sourceMappingURL=GA4ItemListType.js.map